(function () {
  'use strict';

  var loadPromise = null;
  var pendingActions = [];

  function getScriptRoot() {
    return document.querySelector('[data-cart-drawer-scripts]');
  }

  function getScriptUrls() {
    var root = getScriptRoot();
    if (!root) return [];

    return [
      root.getAttribute('data-cart-drawer-src'),
      root.getAttribute('data-cart-confetti-src')
    ].filter(Boolean);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Failed to load ' + src));
      };
      document.head.appendChild(script);
    });
  }

  function flushPendingActions() {
    var actions = pendingActions.slice();
    pendingActions = [];
    actions.forEach(function (run) {
      try {
        run();
      } catch (error) {
        /* ignore */
      }
    });
  }

  function loadCartScripts() {
    if (window.__rabitatCartDrawerLoaded) {
      flushPendingActions();
      return Promise.resolve();
    }

    if (loadPromise) return loadPromise;

    var urls = getScriptUrls();
    if (!urls.length) return Promise.resolve();

    loadPromise = urls.reduce(function (chain, url) {
      return chain.then(function () {
        return loadScript(url);
      });
    }, Promise.resolve()).then(flushPendingActions);

    return loadPromise;
  }

  function queueUntilLoaded(action) {
    if (window.__rabitatCartDrawerLoaded) {
      action();
      return;
    }

    pendingActions.push(action);
    loadCartScripts();
  }

  function installStub() {
    window.RabitatCart = window.RabitatCart || {};

    if (typeof window.RabitatCart.openDrawerForAdd !== 'function') {
      window.RabitatCart.openDrawerForAdd = function (options) {
        queueUntilLoaded(function () {
          if (window.RabitatCart && typeof window.RabitatCart.openDrawerForAdd === 'function') {
            window.RabitatCart.openDrawerForAdd(options);
          }
        });
      };
    }

    if (typeof window.RabitatCart.syncCartAfterAdd !== 'function') {
      window.RabitatCart.syncCartAfterAdd = function () {
        queueUntilLoaded(function () {
          if (window.RabitatCart && typeof window.RabitatCart.syncCartAfterAdd === 'function') {
            window.RabitatCart.syncCartAfterAdd.apply(window.RabitatCart, arguments);
          }
        });
      };
    }
  }

  function shouldEagerLoad() {
    return !!(
      document.querySelector('[data-cart-page]') ||
      document.querySelector('[data-cart-drawer][data-open-on-add="true"]')
    );
  }

  function bindTriggers() {
    document.addEventListener(
      'click',
      function (event) {
        var cartLink = event.target.closest('[data-rabitat-cart-link]');
        if (cartLink) {
          if (!window.__rabitatCartDrawerLoaded) {
            event.preventDefault();
            event.stopPropagation();
            loadCartScripts().then(function () {
              if (typeof window.openCartDrawer === 'function') {
                window.openCartDrawer({ animate: true });
              }
              if (typeof window.refreshCartDrawer === 'function') {
                window.refreshCartDrawer({ open: true, focus: false, expectedCount: null });
              }
            });
          }
          return;
        }

        if (event.target.closest('[data-cart-drawer-close], [data-cart-gift-add], [data-cart-qty-change]')) {
          loadCartScripts();
        }
      },
      true
    );

    document.addEventListener('rabitat:cart:updated', function () {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;

      if (drawer.getAttribute('data-open-on-add') === 'true' || drawer.classList.contains('is-open')) {
        loadCartScripts();
      }
    });
  }

  installStub();
  bindTriggers();

  if (shouldEagerLoad()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadCartScripts);
    } else {
      loadCartScripts();
    }
  }

  window.RabitatCartLoader = {
    load: loadCartScripts,
    queueUntilLoaded: queueUntilLoaded,
  };
})();
